import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import classNames from 'classnames';
import get from 'lodash/get';

function MenuList(props) {
  const children = React.useMemo(
    () =>
      React.Children.toArray(get(props, 'children')).map(child => {
        const { ...rest } = child.props.innerProps || {};
        const tempProps = { ...child.props, ...{ innerProps: rest } };

        return <components.Option {...tempProps} key={rest.id} />;
      }),
    [props.children]
  );

  return (
    <components.MenuList {...props}>{children.length > 5 ? children.slice(0, 5) : props.children}</components.MenuList>
  );
}

MenuList.propTypes = {
  children: PropTypes.node
};

const NewReactSelectInput = props => {
  const {
    meta: { touched, error },
    hooks,
    menuPlacement,
    label,
    isClearable = true,
    inputProps,
    input,
    editingCustomer
  } = props;

  const reactSelectClassNames = classNames({
    'react-select-warning-border': input.name == 'tax_regime' && !props.selectValue && editingCustomer,
    'react-select': props.placeholder !== 'Buscar producto',
    'react-select-filter-option': !!props.selectFilterOption,
    'react-select react-select-concept-search': props.placeholder === 'Buscar producto',
    'react-select-error-border': !!props.meta && touched && error,
    'react-select-modal': !!props.modal
  });
  const options = get(props, 'options', []);
  const initValue = options.find(e => e.value === get(props, 'meta.initial'));
  const alternativeValue = options.find(e => e.value === get(props, 'input.value.value'));
  // NOTE: This value is to avoid errors in modals that by default has a value of 1050
  const zIndex = 1051;

  return (
    <React.Fragment>
      {label && (
        <label id={`aria-label-${label}`} htmlFor={`aria-${label}`}>
          {label}
        </label>
      )}
      <Select
        {...props}
        inputProps={{ ...inputProps, autoComplete: 'off' }}
        onChange={value => {
          if (hooks && typeof hooks.blockOnChange === 'function') {
            if (hooks.blockOnChange(value)) return;
          }

          props.input.onChange(value);

          if (hooks && typeof props.hooks.change === 'function')
            props.hooks.change(get(value, 'amount', 0), props.item.item, props.item.index, props.item.table);
        }}
        value={props.selectValue !== undefined ? props.selectValue : alternativeValue ? alternativeValue : initValue}
        filterOption={props.selectFilterOption}
        placeholder={props.placeholder}
        noOptionsMessage={() =>
          props.placeholder === 'Buscar Cliente'
            ? 'No se han encontrado clientes con facturas por pagar'
            : 'Sin resultados'
        }
        className={reactSelectClassNames}
        classNamePrefix='react-select'
        isClearable={isClearable}
        isDisabled={!!props.isDisabled}
        components={props.placeholder === 'Actividad económica' ? { MenuList } : {}}
        onBlur={() => {
          if (props.hooks && typeof props.hooks.update === 'function') return props.hooks.update(props.item.table);
        }}
        styles={{ menuPortal: base => ({ ...base, zIndex }) }}
        menuPortalTarget={props.placeholder !== 'RFC' && document.body}
        menuPlacement={menuPlacement || 'bottom'}
        aria-labelledby={label && `aria-label-${label}`}
        inputId={label && `aria-${label}`}
      />
      {touched && error && (
        <p className={!props.modal ? 'react-select-error' : 'react-select-error react-select-error-modal'}>
          {error}
        </p>
      )}
    </React.Fragment>
  );
}; // END

NewReactSelectInput.propTypes = {
  meta: PropTypes.object,
  hooks: PropTypes.object,
  menuPlacement: PropTypes.any,
  label: PropTypes.string,
  isClearable: PropTypes.any,
  inputProps: PropTypes.any,
  placeholder: PropTypes.string,
  modal: PropTypes.any,
  input: PropTypes.object,
  item: PropTypes.object,
  selectValue: PropTypes.any,
  selectFilterOption: PropTypes.any,
  isDisabled: PropTypes.any
};

export default NewReactSelectInput;



// WEBPACK FOOTER //
// ./src/components/form/NewReactSelectInput.js